export default __webpack_public_path__ + "static/media/holandia.2636edb0.jpg";